import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const CBSYSLIBRE_SCHEMA_LITERAL = {
    title: 'Schéma cbSysLibre',
    description: 'cbSysLibre',
    version: 0,
    keyCompression: false,
    primaryKey: { key : 'CB_ID', fields : ['CB_FILE', 'CB_NAME'], separator : '' },
    type: 'object',
    properties: {
        CB_ID: { type: 'string', maxLength : 200 },
        CB_FILE: { type: 'string' },
        CB_NAME: { type: 'string' },
        CB_POS: { type: 'number' },
        CB_TYPE: { type: 'number' },
        CB_LEN: { type: 'number' },
        CB_FORMULE: { type: ['string', 'null'] }
    },
    required: [ 'CB_ID', 'CB_FILE', 'CB_POS', 'CB_TYPE', 'CB_LEN' ]
} as const;

const schemaTyped = toTypedRxJsonSchema(CBSYSLIBRE_SCHEMA_LITERAL);
export type RxCbSysLibreDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const CBSYSLIBRE_SCHEMA: RxJsonSchema<RxCbSysLibreDocumentType> = CBSYSLIBRE_SCHEMA_LITERAL;
